import { render, staticRenderFns } from "./LogoComponents.vue?vue&type=template&id=15123620&"
import script from "./LogoComponents.vue?vue&type=script&lang=js&"
export * from "./LogoComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports